<template>
  <div>
    <div class="terms">
      <div v-for="t in course.practical_terms" :key="t.title" class="term">
        <b>{{ t.title }}</b>
        <span v-html="t.body" />
      </div>
    </div>
    <div class="notes">
      <p v-html="course.practical_note_1" />
      <p v-html="course.practical_note_2" />
    </div>
    <div class="sessions">
      <div v-for="s in course.sessions" :key="s.id" class="ss">
        <div class="ss-left">
          <div class="ss-date">
            <i>{{ month(s) }}</i>
            <b>{{ day(s) }}</b>
          </div>
        </div>
        <div class="ss-main">
          <b>{{ s.title }}</b>
          <span>{{ s.time_label }} · {{ s.location }}</span>
        </div>
        <div class="ss-right">
          <button type="button" class="cal-btn">
            <span class="cal-ic">📅</span> Add to calendar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PracticalInfo',
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  methods: {
    month (s) {
      return new Date(s.start_dt.replace(' ', 'T')).toLocaleDateString(
        'en-GB',
        { month: 'short' }
      )
    },
    day (s) {
      return new Date(s.start_dt.replace(' ', 'T')).toLocaleDateString(
        'en-GB',
        { day: 'numeric' }
      )
    }
  }
}
</script>

<style scoped>
.terms {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.term {
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 14px 16px;
  background: var(--paper);
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.term b {
  font-size: 0.9rem;
}
.term span {
  font-size: 0.85rem;
  color: var(--ink-soft);
}
.notes p {
  font-size: 0.88rem;
  color: var(--ink-soft);
  margin: 0 0 10px;
}
.sessions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
}
.ss {
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 14px 16px;
  background: var(--white);
}
.ss-date {
  width: 58px;
  height: 58px;
  border-radius: 12px;
  background: var(--teal-dk);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.ss-date i {
  font-style: normal;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #8fd2dc;
}
.ss-date b {
  font-size: 1.3rem;
  line-height: 1;
}
.ss-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}
.ss-main b {
  font-size: 0.98rem;
}
.ss-main span {
  font-size: 0.83rem;
  color: var(--ink-soft);
}
.cal-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--line);
  background: var(--white);
  border-radius: 999px;
  padding: 9px 14px;
  font-size: 0.83rem;
  font-weight: 600;
  color: var(--ink);
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
}
.cal-btn:hover {
  border-color: var(--teal);
  color: var(--teal-dk);
}
.cal-ic {
  font-size: 0.9rem;
}
</style>

<style>
.term span a,
.notes a {
  color: var(--teal-dk);
}
</style>
